module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-ES.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-ES.png
// module id = OCfN
// module chunks = 1